window.customElements.define(
  'custom-table-scroll-button',
  class extends HTMLElement {
    connectedCallback() {
      this.initDOMElements();
      this.handleScroll();
    }

    initDOMElements() {
      this.scrollToSelector = document.querySelector(this.dataset.scrollToSelector);
    }

    handleScroll() {
      this.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.scrollToSelector) {
          this.scrollToSelector.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
    }
  }
);
